import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const PURCHASES = [{
  name: 'María G.',
  city: 'Rosario',
  time: '3 minutos'
}, {
  name: 'Luciana P.',
  city: 'Córdoba',
  time: '7 minutos'
}, {
  name: 'Daniela R.',
  city: 'Buenos Aires',
  time: '12 minutos'
}, {
  name: 'Florencia M.',
  city: 'Mendoza',
  time: '15 minutos'
}, {
  name: 'Romina S.',
  city: 'Santa Fe',
  time: '18 minutos'
}, {
  name: 'Valentina L.',
  city: 'Tucumán',
  time: '22 minutos'
}, {
  name: 'Camila B.',
  city: 'La Plata',
  time: '25 minutos'
}, {
  name: 'Agustina D.',
  city: 'Salta',
  time: '28 minutos'
}];
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay
    const startTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    return () => clearTimeout(startTimeout);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, 4000); // Wait 4 seconds before showing next
    }, 8000); // Show for 4 seconds (8s total cycle - 4s wait)
    return () => clearInterval(cycleInterval);
  }, [isVisible]);
  const purchase = PURCHASES[index];
  return <AnimatePresence data-id="element-168">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-4 left-4 z-40 max-w-xs w-full" data-id="element-169">
          <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-start gap-3" data-id="element-170">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-171">
              <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-172" />
            </div>
            <div data-id="element-173">
              <p className="text-sm font-bold text-gray-900" data-id="element-174">
                {purchase.name} de {purchase.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-175">
                compró el Mega Pack hace {purchase.time}
              </p>
              <div className="mt-1 flex items-center gap-1" data-id="element-176">
                <span className="block w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-177" />
                <span className="text-[10px] text-gray-500 font-medium" data-id="element-178">
                  Verificado recientemente
                </span>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}